import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class AudioApiManager extends BaseApiManager {
  private static instance: AudioApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): AudioApiManager {
    if (!AudioApiManager.instance) {
      AudioApiManager.instance = new AudioApiManager();
    }
    return AudioApiManager.instance;
  }

  public async getBackgroundAudioMetadata(): Promise<ApiResponse<any>> {
    return this.request('/core/utility/stream/background-audio', {
      method: 'HEAD',
      customHeaders: {},
    });
  }

  public async fetchAudioRange(start: number, end?: number): Promise<Blob> {
    const rangeValue = typeof end === 'number' ? `bytes=${start}-${end}` : `bytes=${start}-`;
    
    const token = this.getToken();
    const headers: Record<string, string> = {};
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    headers['Range'] = rangeValue;

    const response = await fetch(`${this.baseUrl}/core/utility/stream/background-audio`, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to fetch audio range`);
    }

    return response.blob();
  }
}
